module.exports = __webpack_public_path__ + "img/placeholder_desktop.5bf045a6.svg";